/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonNameInfo,
  PersonNameInfoOptional,
  PersonNameInfoMetaI,
  PersonNameInfoTrackedI,
} from "./person-name-info";
import { PersonNameInfoTracked, PersonNameInfoMeta } from "./person-name-info";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";

/**
 *
 * @export
 * @interface PersonNameInfoAndRef
 */
export interface PersonNameInfoAndRefOptional extends PersonNameInfoOptional {
  /**
   *
   * @type {number}
   * @memberof PersonNameInfoAndRef
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  organization?: string;
}

export interface PersonNameInfoAndRef
  extends PersonNameInfoAndRefOptional, PersonNameInfo, PersonRef {
  /**
   *
   * @type {number}
   * @memberof PersonNameInfoAndRef
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  organization?: string;
}

export interface PersonNameInfoAndRefTrackedI extends PersonNameInfoOptional {
  /**
   *
   * @type {number}
   * @memberof PersonNameInfoAndRef
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  prefix?: string;
  prefixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  first?: string;
  firstIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  middle?: string;
  middleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  last?: string;
  lastIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  suffix?: string;
  suffixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  preferred?: string;
  preferredIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfoAndRef
   */
  organization?: string;
  organizationIsSet: boolean;
}

transformDatesMap.set(
  "PersonNameInfoAndRef",
  function (model: PersonNameInfoAndRef) {},
);

export type PersonNameInfoAndRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  prefix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  first: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  middle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  last: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  suffix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  preferred: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  organization: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PersonNameInfoAndRefMeta: PersonNameInfoAndRefMetaI =
  {} as PersonNameInfoAndRefMetaI;
PersonNameInfoAndRefMeta = typeMeta("PersonNameInfoAndRef", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  prefix: propertyMeta("prefix", false, false, false, MetaTypesBase.string),
  first: propertyMeta("first", false, false, false, MetaTypesBase.string),
  middle: propertyMeta("middle", false, false, false, MetaTypesBase.string),
  last: propertyMeta("last", false, false, false, MetaTypesBase.string),
  suffix: propertyMeta("suffix", false, false, false, MetaTypesBase.string),
  preferred: propertyMeta(
    "preferred",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  organization: propertyMeta(
    "organization",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = PersonNameInfoAndRefMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonRefMeta]);
  metaI.assignId.inheritedFrom = PersonRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([PersonNameInfoMeta]);
  metaI.prefix.inheritedFrom = PersonNameInfoMeta.prefix;
  metaI.first.inheritedFrom = PersonNameInfoMeta.first;
  metaI.middle.inheritedFrom = PersonNameInfoMeta.middle;
  metaI.last.inheritedFrom = PersonNameInfoMeta.last;
  metaI.suffix.inheritedFrom = PersonNameInfoMeta.suffix;
  metaI.preferred.inheritedFrom = PersonNameInfoMeta.preferred;
  metaI.organization.inheritedFrom = PersonNameInfoMeta.organization;
});

export class PersonNameInfoAndRefTracked
  extends PersonNameInfoTracked
  implements PersonNameInfoAndRefTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  prefix__I?: string = undefined;
  prefixIsSet: boolean = false;
  set prefix(v: undefined | string) {
    if (v !== undefined) {
      this.prefix__I = v;
      this.prefixIsSet = true;
    } else {
      this.prefix__I = v || undefined;
      this.prefixIsSet = false;
    }
    this.changeTracker = true;
  }
  get prefix() {
    return this.prefix__I;
  }
  first__I?: string = undefined;
  firstIsSet: boolean = false;
  set first(v: undefined | string) {
    if (v !== undefined) {
      this.first__I = v;
      this.firstIsSet = true;
    } else {
      this.first__I = v || undefined;
      this.firstIsSet = false;
    }
    this.changeTracker = true;
  }
  get first() {
    return this.first__I;
  }
  middle__I?: string = undefined;
  middleIsSet: boolean = false;
  set middle(v: undefined | string) {
    if (v !== undefined) {
      this.middle__I = v;
      this.middleIsSet = true;
    } else {
      this.middle__I = v || undefined;
      this.middleIsSet = false;
    }
    this.changeTracker = true;
  }
  get middle() {
    return this.middle__I;
  }
  last__I?: string = undefined;
  lastIsSet: boolean = false;
  set last(v: undefined | string) {
    if (v !== undefined) {
      this.last__I = v;
      this.lastIsSet = true;
    } else {
      this.last__I = v || undefined;
      this.lastIsSet = false;
    }
    this.changeTracker = true;
  }
  get last() {
    return this.last__I;
  }
  suffix__I?: string = undefined;
  suffixIsSet: boolean = false;
  set suffix(v: undefined | string) {
    if (v !== undefined) {
      this.suffix__I = v;
      this.suffixIsSet = true;
    } else {
      this.suffix__I = v || undefined;
      this.suffixIsSet = false;
    }
    this.changeTracker = true;
  }
  get suffix() {
    return this.suffix__I;
  }
  preferred__I?: string = undefined;
  preferredIsSet: boolean = false;
  set preferred(v: undefined | string) {
    if (v !== undefined) {
      this.preferred__I = v;
      this.preferredIsSet = true;
    } else {
      this.preferred__I = v || undefined;
      this.preferredIsSet = false;
    }
    this.changeTracker = true;
  }
  get preferred() {
    return this.preferred__I;
  }
  organization__I?: string = undefined;
  organizationIsSet: boolean = false;
  set organization(v: undefined | string) {
    if (v !== undefined) {
      this.organization__I = v;
      this.organizationIsSet = true;
    } else {
      this.organization__I = v || undefined;
      this.organizationIsSet = false;
    }
    this.changeTracker = true;
  }
  get organization() {
    return this.organization__I;
  }
  constructor(config?: PersonNameInfoAndRefOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: PersonNameInfoAndRefOptional,
    options?: AssignOptions,
  ): PersonNameInfoAndRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.prefix && this.prefixApplyFilter(optionsRequired.filter)) {
      this.prefix = config.prefix;
      if (optionsRequired.unassign) this.prefixIsSet = false;
      else this.prefixIsSet = true;
    }
    if (config.first && this.firstApplyFilter(optionsRequired.filter)) {
      this.first = config.first;
      if (optionsRequired.unassign) this.firstIsSet = false;
      else this.firstIsSet = true;
    }
    if (config.middle && this.middleApplyFilter(optionsRequired.filter)) {
      this.middle = config.middle;
      if (optionsRequired.unassign) this.middleIsSet = false;
      else this.middleIsSet = true;
    }
    if (config.last && this.lastApplyFilter(optionsRequired.filter)) {
      this.last = config.last;
      if (optionsRequired.unassign) this.lastIsSet = false;
      else this.lastIsSet = true;
    }
    if (config.suffix && this.suffixApplyFilter(optionsRequired.filter)) {
      this.suffix = config.suffix;
      if (optionsRequired.unassign) this.suffixIsSet = false;
      else this.suffixIsSet = true;
    }
    if (config.preferred && this.preferredApplyFilter(optionsRequired.filter)) {
      this.preferred = config.preferred;
      if (optionsRequired.unassign) this.preferredIsSet = false;
      else this.preferredIsSet = true;
    }
    if (
      config.organization &&
      this.organizationApplyFilter(optionsRequired.filter)
    ) {
      this.organization = config.organization;
      if (optionsRequired.unassign) this.organizationIsSet = false;
      else this.organizationIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonNameInfoAndRefTrackedI {
    const cloned = {} as PersonNameInfoAndRefTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.prefixIsSetDeep() &&
      this.prefixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prefixIsSet = true;
      cloned.prefix = this.prefix;
    } else {
      //cloned.prefixIsSet = false
    }
    if (
      this.firstIsSetDeep() &&
      this.firstApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.firstIsSet = true;
      cloned.first = this.first;
    } else {
      //cloned.firstIsSet = false
    }
    if (
      this.middleIsSetDeep() &&
      this.middleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.middleIsSet = true;
      cloned.middle = this.middle;
    } else {
      //cloned.middleIsSet = false
    }
    if (
      this.lastIsSetDeep() &&
      this.lastApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lastIsSet = true;
      cloned.last = this.last;
    } else {
      //cloned.lastIsSet = false
    }
    if (
      this.suffixIsSetDeep() &&
      this.suffixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.suffixIsSet = true;
      cloned.suffix = this.suffix;
    } else {
      //cloned.suffixIsSet = false
    }
    if (
      this.preferredIsSetDeep() &&
      this.preferredApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.preferredIsSet = true;
      cloned.preferred = this.preferred;
    } else {
      //cloned.preferredIsSet = false
    }
    if (
      this.organizationIsSetDeep() &&
      this.organizationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.organizationIsSet = true;
      cloned.organization = this.organization;
    } else {
      //cloned.organizationIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonNameInfoAndRefTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.prefixApplyFilter(filter)) this.prefixIsSet = false;

    if (!this.firstApplyFilter(filter)) this.firstIsSet = false;

    if (!this.middleApplyFilter(filter)) this.middleIsSet = false;

    if (!this.lastApplyFilter(filter)) this.lastIsSet = false;

    if (!this.suffixApplyFilter(filter)) this.suffixIsSet = false;

    if (!this.preferredApplyFilter(filter)) this.preferredIsSet = false;

    if (!this.organizationApplyFilter(filter)) this.organizationIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoAndRefMeta.assignId,
      PersonNameInfoAndRefMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  prefixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoAndRefMeta.prefix,
      PersonNameInfoAndRefMeta,
      this.prefix,
      this,
    );
  }
  prefixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.prefixIsSet && this.prefixApplyFilter(filter)) return true;

    return false;
  }
  firstApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoAndRefMeta.first,
      PersonNameInfoAndRefMeta,
      this.first,
      this,
    );
  }
  firstIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.firstIsSet && this.firstApplyFilter(filter)) return true;

    return false;
  }
  middleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoAndRefMeta.middle,
      PersonNameInfoAndRefMeta,
      this.middle,
      this,
    );
  }
  middleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.middleIsSet && this.middleApplyFilter(filter)) return true;

    return false;
  }
  lastApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoAndRefMeta.last,
      PersonNameInfoAndRefMeta,
      this.last,
      this,
    );
  }
  lastIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lastIsSet && this.lastApplyFilter(filter)) return true;

    return false;
  }
  suffixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoAndRefMeta.suffix,
      PersonNameInfoAndRefMeta,
      this.suffix,
      this,
    );
  }
  suffixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.suffixIsSet && this.suffixApplyFilter(filter)) return true;

    return false;
  }
  preferredApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoAndRefMeta.preferred,
      PersonNameInfoAndRefMeta,
      this.preferred,
      this,
    );
  }
  preferredIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.preferredIsSet && this.preferredApplyFilter(filter)) return true;

    return false;
  }
  organizationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoAndRefMeta.organization,
      PersonNameInfoAndRefMeta,
      this.organization,
      this,
    );
  }
  organizationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.organizationIsSet && this.organizationApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.prefixIsSetDeep(filter)) return true;
    if (this.firstIsSetDeep(filter)) return true;
    if (this.middleIsSetDeep(filter)) return true;
    if (this.lastIsSetDeep(filter)) return true;
    if (this.suffixIsSetDeep(filter)) return true;
    if (this.preferredIsSetDeep(filter)) return true;
    if (this.organizationIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
